import vendorListJson from '../resource/vendorlist';
import { VendorList } from 'consent-string';

export default function getVendorListJson(): VendorList {
    return vendorListJson as any;
}
